import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../components/home'
import lockpage from '../components/lockpage/lockpage'
Vue.use(VueRouter)

const routes = [
   {//主页
    path:"/",
    name:"home",
    component:home
  },
  {//门锁商品页
    path:"/Merchandise_page/:name",
    name:"Merchandise_page",
    component:lockpage
  },
    {//主页
      path: '*', // 匹配所有路由
    redirect: '/'
    },
]

const router = new VueRouter({
  routes
})


export default router
